export const getNewUrl = (currentUrl: string, destination: string): string => {
  return currentUrl.replace(
    currentUrl.substring(currentUrl.lastIndexOf('/')),
    destination,
  );
};
